import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { AdvancedMapComponent } from './components/advanced-map/advanced-map.component';
import { CustomerComponent } from './components/customer/customer.component';
import { AiComponent } from './components/ai/ai.component';
import { OperationsComponent } from './components/operations/operations.component';
import { MeterManagementComponent } from './components/meter-management/meter-management.component';
import { ReadingsComponent } from './components/readings/readings.component';
import { EditMvPoleComponent } from './components/mv-pole/edit-mv-pole/edit-mv-pole.component';
import { MvPoleListComponent } from './components/mv-pole/mv-pole-list/mv-pole-list.component';
import { DetailSidebarLayoutComponent } from './components/detail-sidebar-layout/detail-sidebar-layout.component';
import { CrudComponent } from './components/crud/crud.component';
import { AddNewNetworkDeviceFieldComponent } from './components/crud/crud-section-definitions/add-new-network-device-field/add-new-network-device-field.component';
import { AuthGuard } from './services/guards/auth-guard';
import { AddNewCustomerAccountComponent } from './components/crud/crud-customer-accounts/add-new-customer-account/add-new-customer-account.component';
import { MapLayoutComponent } from './components/map-layout/map-layout.component';
import { SubstationListComponent } from './components/asset-list/substations/substation-list/substation-list.component';
import { NetworkAssetComponent } from './components/network-asset/network-asset.component';
import { DetailSidebarItems } from './enums/detail-sidebar-items';
import { BpsAdminDashboardComponent } from './components/bps-admin/bps-admin-dashboard/bps-admin-dashboard.component';
import { BpsAuthGuard } from './services/guards/bps-guard';
import { BpsAdminJobHistoryComponent } from './components/bps-admin/bps-admin-job-history/bps-admin-job-history.component';
import { AuditLogComponent } from './components/bps-admin/audit-log/audit-log/audit-log.component';
import { UtilityAssetAndCustomerEntitiesComponent } from './components/bps-admin/utility-asset-and-customer-entities/utility-asset-and-customer-entities.component';
import { UtilityManagementComponent } from './components/bps-admin/utility-management/utility-management/utility-management.component';
import { WorkflowConfigurationComponent } from './components/workflow-configuration/workflow-configuration.component';
import { AddUtilityComponent } from './components/bps-admin/utility-management/add-utility/add-utility.component';
import { AddNewModuleComponent } from './components/workflow-configuration/add-new-module/add-new-module.component';
import { RoleAndPermissionsComponent } from './components/role-and-permissions/role-and-permissions.component';
import { EntityModelCustomizationComponent } from './components/entity-model-customization/entity-model-customization.component';
// import { DynamicSubstationListComponent } from './components/dynamic-asset-list/dynamic-substation-list/dynamic-substation-list.component';
import { SettingsSidenavComponent } from './components/sidenavs/settings-sidenav/settings-sidenav.component';
import { AssetListSidenavComponent } from './components/sidenavs/asset-list-sidenav/asset-list-sidenav.component';
// import { CimSubstationListComponent } from './components/cim-substations/cim-substation-list/cim-substation-list.component';
// import { EditCimSubstationComponent } from './components/cim-substations/edit-cim-substation/edit-cim-substation.component';

import { DashboardConfiguration, PermissionsEnum } from 'shared-lib';

// lib imports
import { 
  AiJobMonitoringComponent,
  AiOverviewComponent,
  AiSegmentationListComponent,
  BatchImageImportComponent,
  EditInjectionSubstationComponent,
  DashboardComponent as SharedDashboardComponent,
  DataModelCustomizationComponent,
  LoginComponent,
  ForgotPasswordComponent,
  HelpComponent,
  NetworkEntityClassesComponent,
  NetworkModelCustomizationComponent,
  DynamicSubstationListComponent,
  AddEquipmentAndConnectivityComponent,
  EditCimSubstationComponent,
  CimSubstationListComponent,
  CimEquipmentListComponent,
  EditCimEquipmentComponent,
  OtpVerificationComponent
 } from 'shared-lib';


//Components
const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'verify-otp',
    component: OtpVerificationComponent,
    pathMatch: 'full',
  },
  {
    path: 'help',
    component: HelpComponent,
    pathMatch: 'full',
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    pathMatch: 'full',
  },
  {
    path: '',
    component: MapLayoutComponent,
    children: [
      {
        path: 'map',
        canActivate: [AuthGuard],
        component: AdvancedMapComponent,
      },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        component: SharedDashboardComponent,
      },
      {
        path: 'settings/crud/12/add-customer',
        canActivate: [AuthGuard],
        component: AddNewCustomerAccountComponent,
      },
      {
        path: 'network-assets',
        component: DetailSidebarLayoutComponent,
        data: {
          sidebarItems: [
            { label: 'Assembly', iconKey: 'assembly.svg', route: '' },
            { label: 'Equipments', iconKey: 'devices.svg', route: 'devices' },
            { label: 'Lines', iconKey: 'lines.svg', route: '' },
            {
              label: 'Voltage Levels',
              iconKey: 'voltage-levels.svg',
              route: '',
            },
            { label: 'Configuration', iconKey: 'configuration.svg', route: '' },
          ],
          sidebarTitle: 'Network Asset',
        },
        children: [
          {
            path: '',
            component: NetworkAssetComponent,
          },
        ],
      },
      {
        path: 'ai',
        redirectTo: 'ai/overview',
        pathMatch: 'full',
      },
      {
        path: 'ai',
        canActivate: [AuthGuard],
        component: DetailSidebarLayoutComponent,
        data: {
          sidebarItems: [
            {
              label: 'AI.OVERVIEW',
              iconKey: 'ai-overview.svg',
              route: 'overview',
              permission: 'isAIUAVOverviewAllowed'
            },
            {
              label: 'AI.BATCH_IMAGE_IMPORT',
              iconKey: 'ai-bi.svg',
              route: 'batch-image-import',
              permission: 'isAIUAVBatchImageImportAllowed'
            },
            {
              label: 'AI.AI_SEGMENTATION_LIST',
              iconKey: 'ai-sl.svg',
              route: 'segmentation-list',
              permission: 'isAIUAVSegmentationListAllowed'
            },
            {
              label: 'AI.JOB_MONITORING.TITLE',
              iconKey: 'ai-jm.svg',
              route: 'job-monitoring',
              permission: 'isAIUAVJobMonitoringAllowed'
            },
          ],
          sidebarTitle: 'AI.TITLE_NEW',
        },
        children: [
          {
            path: '',
            canActivate: [AuthGuard],
            component: AiComponent,
          },
          {
            path: 'overview',
            canActivate: [AuthGuard],
            component: AiOverviewComponent,
            data: {
              configuration: DashboardConfiguration.AIDroneMap,
              permission: [PermissionsEnum.AI_UAV_Overview]
            }
          },
          {
            path: 'batch-image-import',
            canActivate: [AuthGuard],
            component: BatchImageImportComponent,
            data: {
              configuration: DashboardConfiguration.AIDroneMap,
              permission: [PermissionsEnum.AI_UAV_Batch_Image_Import]
            }
          },
          {
            path: 'segmentation-list',
            canActivate: [AuthGuard],
            component: AiSegmentationListComponent,
            data: {
              configuration: DashboardConfiguration.AIDroneMap,
              permission: [PermissionsEnum.AI_UAV_Segmentation_List]
            }
          },
          {
            path: 'job-monitoring',
            canActivate: [AuthGuard],
            component: AiJobMonitoringComponent,
            data: {
              configuration: DashboardConfiguration.AIDroneMap,
              permission: [PermissionsEnum.AI_UAV_Job_Monitoring]
            }
          },
        ],
      },
      {
        path: 'customers',
        canActivate: [AuthGuard],
        component: CustomerComponent,
      },
      {
        path: 'customers/crud-edit/:id',
        canActivate: [AuthGuard],
        component: AddNewCustomerAccountComponent,
      },
      {
        path: 'asset-list/mv-poles/edit/:id',
        canActivate: [AuthGuard],
        component: EditMvPoleComponent,
      },
      {
        path: 'asset-list/substations/edit/:guid',
        canActivate: [AuthGuard],
        component: EditInjectionSubstationComponent,
        data: {
          configuration: DashboardConfiguration.InjectionSubstation,
        }
      },
      {
        path: 'asset-list/cim-substations/:id/edit/:guid',
        canActivate: [AuthGuard],
        component: EditCimSubstationComponent,
        data: {
          permission: [PermissionsEnum.NetworkStructure_View],
        }
      },
      {
        path: 'asset-list/cim-equipment/:cimClass/edit/:guid',
        canActivate: [AuthGuard],
        component: EditCimEquipmentComponent,
      },
      {
        path: 'asset-list',
        canActivate: [AuthGuard],
        component: AssetListSidenavComponent,
        children: [
          {
            path: 'edit/cim-substation',
            canActivate: [AuthGuard],
            component: EditCimSubstationComponent,
          },
          {
            path: 'mv-poles',
            canActivate: [AuthGuard],
            component: MvPoleListComponent,
          },
          {
            path: 'substations',
            canActivate: [AuthGuard],
            component: DynamicSubstationListComponent,
            data: {
              configuration: DashboardConfiguration.InjectionSubstation,
            }
          },
          {
            path: 'cim-substations/:id',
            canActivate: [AuthGuard],
            component: CimSubstationListComponent,
            data: {
              permission: [PermissionsEnum.NetworkStructure_View],
            }
          },
          {
            path: 'cim-equipment/:cimClass',
            canActivate: [AuthGuard],
            component: CimEquipmentListComponent
          }
        ],
      },
      {
        path: 'operations',
        canActivate: [AuthGuard],
        component: OperationsComponent,
      },
      {
        path: 'meter-management',
        canActivate: [AuthGuard],
        component: MeterManagementComponent,
      },
      {
        path: 'readings',
        canActivate: [AuthGuard],
        component: ReadingsComponent,
        data: {
          configuration: DashboardConfiguration.Readings,
          permission: [PermissionsEnum.Readings_View]
        }
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        component: SettingsSidenavComponent,
        children: [
          {
            path: 'network-structure',
            canActivate: [AuthGuard],
            component: NetworkModelCustomizationComponent,
            data: {
              configuration: DashboardConfiguration.NetworkModelStructure,
              permission: [PermissionsEnum.NetworkStructure_View]
            }
          },
          {
            path: 'network-structure/add-equipment-and-connectivity/:id',
            canActivate: [AuthGuard],
            component: AddEquipmentAndConnectivityComponent,
            data: { 
              configuration: DashboardConfiguration.NetworkModelStructure,
              permission: [PermissionsEnum.NetworkStructure_View]
            },
          },
          {
            path: 'data-model-customization',
            redirectTo: 'data-model-customization/assets/0',
            pathMatch: 'full',

          },
          {
            path: 'network-entity-classes/:id',
            canActivate: [AuthGuard],
            component: NetworkEntityClassesComponent,
            data: {
              configuration: DashboardConfiguration.NetworkEntityClassInstantiation,
              permission: [PermissionsEnum.NetworkEntityClasses_View]
            }
          },
          {
            path: 'role-management',
            canActivate: [AuthGuard],
            component: RoleAndPermissionsComponent,
          },
          {
            path: 'data-model-customization/:modelType/:id',
            canActivate: [AuthGuard],
            component: DataModelCustomizationComponent,
            data: {
              configuration: DashboardConfiguration.DataModelCustomization,
              sidebarItems: [
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_LINES',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_DEVICES',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.BUILDINGS_CUSTOMERS',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.METERS',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.SUBSTATION_TEMPLATES',
              ],
              serviceRequestSidebarItems: [
                'DATA_MODEL_CUSTOMIZATION.CUSTOMER_APPLICATION',
                'DATA_MODEL_CUSTOMIZATION.SERVICE_EXTENSION',
                'DATA_MODEL_CUSTOMIZATION.DEDICATED_SUPPLY_REQUESTS',
                'DATA_MODEL_CUSTOMIZATION.DISCONNECTION_REQUESTS',
              ],
              permission: [PermissionsEnum.DataModelCustomization_View]
            },
          },
          {
            path: 'crud',
            redirectTo: 'crud/0',
            pathMatch: 'full',
          },
          {
            path: 'crud/:id',
            canActivate: [AuthGuard],
            component: CrudComponent,
            data: {
              sidebarItems: [
                'CRUD_SETTINGS.CATEGORIES.TRANSMISSION_STATION',
                'CRUD_SETTINGS.CATEGORIES.MAIN_FEEDER',
                'CRUD_SETTINGS.CATEGORIES.INJECTION_SUBSTATION',
                'CRUD_SETTINGS.CATEGORIES.SUB_FEEDER',
                'CRUD_SETTINGS.CATEGORIES.DISTRIBUTION_TRANSFORMER',
                'CRUD_SETTINGS.CATEGORIES.NETWORK_DEVICE',
                'COMMON.UT.SINGLE',
                'COMMON.BU.SINGLE',
                'CRUD_SETTINGS.CATEGORIES.TARIFF',
                'CRUD_SETTINGS.CATEGORIES.METER_TYPE',
                'CRUD_SETTINGS.CATEGORIES.ASSET_RATING',
                'CRUD_SETTINGS.CATEGORIES.ASSET_STATUS',
                'CRUD_SETTINGS.CATEGORIES.CUSTOMER_ACCOUNTS',
                'CRUD_SETTINGS.CATEGORIES.DT_METER_TYPE',
                'CRUD_SETTINGS.CATEGORIES.SLT_STATUS',
                'CRUD_SETTINGS.CATEGORIES.METER_PRICE',
                'CRUD_SETTINGS.CATEGORIES.BILLING_ACCOUNTS',
              ],
              sidebarTitle: 'MAIN_SIDEBAR.SETTINGS',
            },
            children: [
              {
                path: 'network-device',
                canActivate: [AuthGuard],
                component: AddNewNetworkDeviceFieldComponent,
              },
            ],
          },
        ],
      },
      //BPS Admin
      {
        path: 'utility-management',
        canActivate: [BpsAuthGuard],
        component: DetailSidebarLayoutComponent,
        data: {
          sidebarTitle: 'UTILITY_MANAGEMENT.ADD_UTILITY',
          sidebarItems: [
            {
              label: 'SIDENAV.PROFILE',
              iconKey: 'profile.svg',
              route: 'profile',
            },
            {
              label: 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE',
              iconKey: 'network-structure.svg',
              route: 'network-structure',
            },
            {
              label: 'DATA_MODEL_CUSTOMIZATION.TITLE',
              iconKey: 'dmc.svg',
              route: 'data-model-customization-bps/assets/0',
            },
            {
              label: 'UTILITY_MANAGEMENT.ENTITY_MODEL_CUSTOMIZATION',
              iconKey: 'entity-model.svg',
              route: 'entity-model-customization/0'
            },
          ],
        },
        children: [
          {
            path: 'entity-model-customization/:id',
            canActivate: [BpsAuthGuard],
            component: EntityModelCustomizationComponent,
          },
          {
            path: 'data-model-customization-bps',
            redirectTo: 'data-model-customization-bps/assets/0',
            pathMatch: 'full',
          },
          {
            path: 'data-model-customization-bps/:modelType/:id',
            canActivate: [BpsAuthGuard],
            component: DataModelCustomizationComponent,
           data: {
              configuration: DashboardConfiguration.DataModelCustomization,
              sidebarItems: [
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_LINES',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_DEVICES',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.BUILDINGS_CUSTOMERS',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.METERS',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.SUBSTATION_TEMPLATES',
              ],
              serviceRequestSidebarItems: [
                'DATA_MODEL_CUSTOMIZATION.CUSTOMER_APPLICATION',
                'DATA_MODEL_CUSTOMIZATION.SERVICE_EXTENSION',
                'DATA_MODEL_CUSTOMIZATION.DEDICATED_SUPPLY_REQUESTS',
                'DATA_MODEL_CUSTOMIZATION.DISCONNECTION_REQUESTS',
              ]
            },
          },
          {
            path: 'profile',
            canActivate: [BpsAuthGuard],
            component: AddUtilityComponent,
          },
          {
            path: 'network-structure',
            canActivate: [BpsAuthGuard],
            component: NetworkModelCustomizationComponent,
          },
          {
            path: 'network-structure/add-equipment-and-connectivity/:id',
            canActivate: [BpsAuthGuard],
            component: AddEquipmentAndConnectivityComponent,
          }
        ],
      },

      {
        path: 'settings-bps',
        canActivate: [BpsAuthGuard],
        component: DetailSidebarLayoutComponent,
        data: {
          sidebarItems: [
            {
              label: 'SIDENAV.WORKFLOW_CONFIGURATION',
              iconKey: 'workflow-configuration.svg',
              route: 'workflow-configuration',
            },
            {
              label: 'HEADER_TITLE.UTILITY_MANAGEMENT',
              iconKey: 'utility-management.svg',
              route: 'utility-management',
            },
            {
              label: 'ROLE_MANAGEMENT.USER_MANAGEMENT',
              iconKey: 'user-management.svg',
            },
            {
              label: 'MAIN_SIDEBAR.DETAILS_SIDEBAR.SETTINGS.PROFILE',
              iconKey: 'profile.svg',
            },
            {
              label: 'MAIN_SIDEBAR.DETAILS_SIDEBAR.SETTINGS.CRUD_SETTING',
              iconKey: 'crud.svg',
            },
          ],
          sidebarTitle: 'MAIN_SIDEBAR.SETTINGS',
        },
        children: [
          {
            path: 'utility-management',
            canActivate: [BpsAuthGuard],
            component: UtilityManagementComponent,
          },
          {
            path: 'workflow-configuration',
            canActivate: [BpsAuthGuard],
            component: WorkflowConfigurationComponent,
          },
          {
            path: 'add-new-workflow',
            canActivate: [BpsAuthGuard],
            component: AddNewModuleComponent,
          },
          {
            path: 'data-model-customization-bps/:modelType/:id',
            canActivate: [BpsAuthGuard],
            component: DataModelCustomizationComponent,
            data: {
              configuration: DashboardConfiguration.DataModelCustomization,
              sidebarItems: [
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_STRUCTURE',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_LINES',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.NETWORK_DEVICES',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.BUILDINGS_CUSTOMERS',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.METERS',
                'DATA_MODEL_CUSTOMIZATION.CATEGORIES.SUBSTATION_TEMPLATES',
              ],
              serviceRequestSidebarItems: [
                'DATA_MODEL_CUSTOMIZATION.CUSTOMER_APPLICATION',
                'DATA_MODEL_CUSTOMIZATION.SERVICE_EXTENSION',
                'DATA_MODEL_CUSTOMIZATION.DEDICATED_SUPPLY_REQUESTS',
                'DATA_MODEL_CUSTOMIZATION.DISCONNECTION_REQUESTS',
              ]
            },
          },
          {
            path: 'crud',
            redirectTo: 'crud/0',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'dashboard-bps',
        component: BpsAdminDashboardComponent,
        canActivate: [BpsAuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.DASHBOARD' },
      },
      {
        path: 'job-history',
        component: BpsAdminJobHistoryComponent,
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.BACKGROUND_JOB_HISTORY' },
        canActivate: [BpsAuthGuard],
      },
      {
        path: 'audit-log',
        component: AuditLogComponent,
        canActivate: [BpsAuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.AUDIT_LOG' },
      },
      {
        path: 'assets',
        component: UtilityAssetAndCustomerEntitiesComponent,
        canActivate: [BpsAuthGuard],
        pathMatch: 'full',
        data: { headerTitle: 'HEADER_TITLE.UTILITY_ASSET_CUSTOMER_ENTITIES' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
